import "moment-timezone";

import { ApiListResponse, TaskDTO } from "@gymflow/types";
import { AxiosInstance } from "axios";

import { createSortParam } from "../createSortParam";
import { trimFields } from "./features/trimFiels";

export type TaskApiType = ReturnType<typeof taskApi>;

const taskApi = (axiosInstance: AxiosInstance, clubId: number) => {
  const clubPrefix = `club/${clubId}/`;
  const fieldsToTrim = ["name", "notes"];

  return {
    find({
      page = 0,
      limit = 10,
      extraParams = {},
      sort,
    }: {
      readonly extraParams?: {
        readonly dateFrom?: string;
        readonly dateTo?: string;
        readonly complete?: boolean;
        readonly ["taskOwners.id"]?: string | string[];
        readonly [k: string]: any;
      };
      readonly page?: number;
      readonly limit?: number;
      readonly sort?: {
        readonly field: string;
        readonly desc?: boolean;
      };
    }) {
      const config = {
        params: {
          page,
          size: limit,
          ...extraParams,
        },
      } as any;
      if (sort) {
        config.params.sort = createSortParam(sort);
      }
      return axiosInstance.get<ApiListResponse<TaskDTO>>(
        `${clubPrefix}task`,
        config,
      );
    },
    findById(id: number) {
      return axiosInstance.get<TaskDTO>(`${clubPrefix}task/${id}`);
    },
    create(newResource: { [k: string]: any }) {
      return axiosInstance.post<TaskDTO>(
        `${clubPrefix}task`,
        trimFields(newResource, fieldsToTrim),
      );
    },
    update(id: number, patchedFields: Partial<{ [k: string]: any }>) {
      return axiosInstance.patch(
        `${clubPrefix}task/${id}`,
        trimFields(patchedFields, fieldsToTrim),
      );
    },
    remove(id: number) {
      return axiosInstance.delete(`${clubPrefix}task/${id}`);
    },
  };
};

export default taskApi;
